import { useNavigate, useLocation } from "react-router-dom";
import { Stamp, FileText, Home } from "lucide-react";

/** Compact pill-shaped switcher visible in the top header.
 *
 * Always offers a Home option so the user can return to the workspace
 * picker from any page. Approvals / Creation pills are shown only when
 * the current role has access to that workspace.
 */
export default function WorkspaceSwitcher({ role }) {
  const nav = useNavigate();
  const loc = useLocation();
  const canApprove = ["Authoriser", "Approver", "Both", "Admin"].includes(role);
  const canCreate = !!role; // every logged-in user can create PRs

  const onHome = loc.pathname === "/home";
  const onApprovals = loc.pathname === "/" || loc.pathname.startsWith("/admin") || loc.pathname.startsWith("/pipeline");
  const onCreate = loc.pathname.startsWith("/my-prs") || loc.pathname.startsWith("/create") || loc.pathname.startsWith("/pr/edit") || loc.pathname.startsWith("/pr-review");

  if (!role) return null;

  return (
    <div className="bg-white/10 rounded-lg p-0.5 inline-flex" data-testid="workspace-switcher">
      <button
        onClick={() => nav("/home")}
        data-testid="ws-home"
        className={`px-2 sm:px-2.5 py-1 text-xs font-semibold rounded-md transition-colors inline-flex items-center gap-1 ${onHome ? "bg-white text-cyan-800" : "text-cyan-50 hover:bg-white/10"}`}
        title="Home — workspace picker"
      >
        <Home size={12} /> <span className="hidden sm:inline">Home</span>
      </button>
      {canApprove && (
        <button
          onClick={() => nav("/")}
          data-testid="ws-approvals"
          className={`px-2 sm:px-2.5 py-1 text-xs font-semibold rounded-md transition-colors inline-flex items-center gap-1 ${onApprovals ? "bg-white text-cyan-800" : "text-cyan-50 hover:bg-white/10"}`}
        >
          <Stamp size={12} /> <span className="hidden sm:inline">Approvals</span>
        </button>
      )}
      {canCreate && (
        <button
          onClick={() => nav("/my-prs")}
          data-testid="ws-creation"
          className={`px-2 sm:px-2.5 py-1 text-xs font-semibold rounded-md transition-colors inline-flex items-center gap-1 ${onCreate ? "bg-white text-cyan-800" : "text-cyan-50 hover:bg-white/10"}`}
        >
          <FileText size={12} /> <span className="hidden sm:inline">Creation</span>
        </button>
      )}
    </div>
  );
}
